// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiAnonSurveyBatch/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiAnonSurveyBatch/getRows', payload).then(getData);

export const getRow = (rowID) => http.get(`apiAnonSurveyBatch/getRow&RowID=${rowID}`).then(getData);

export const create = (row) => http.post('apiAnonSurveyBatch/addRow', row).then(getData);

export const remove = (row) => http.post('apiAnonSurveyBatch/deleteRow',row).then(getData);

export const update = (row) => http.post('apiAnonSurveyBatch/editRow',row).then(getData);